import React, { useState } from "react";
import ModalPopup from "../ModalPopup";
import RequestSample from "../Forms/RequestSample";
import EmailAFriend from "../Forms/EmailAFriend/EmailAFriend";

export default function ProductCTAs({ primarySpecSheet = null }) {
  const [sampleModalOpen, setSampleModalOpen] = useState(false);
  const [emailModalOpen, setEmailModalOpen] = useState(false);

  const handleRequestSample = (e) => {
    e.preventDefault();
    e.stopPropagation();
    !sampleModalOpen && setSampleModalOpen(true);
  };

  const handleEmailFriend = (e) => {
    e.preventDefault();
    e.stopPropagation();
    !emailModalOpen && setEmailModalOpen(true);
  };

  return (
    <div className="flex flex-col sm:flex-row gap-7">
      {primarySpecSheet && (
        <a
          href={primarySpecSheet?.file?.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-lg text-black inline-flex items-center bg-white h-14 px-4 border border-black border-solid hover:bg-black hover:text-white"
        >
          View Spec Sheet
        </a>
      )}
      <button
        className="text-lg text-black cursor-pointer inline-flex items-center bg-white h-14 px-4 border border-black border-solid hover:bg-black hover:text-white"
        onClick={(e) => handleEmailFriend(e)}
      >
        Share This Page
      </button>
      <button
        className="text-lg text-black inline-flex cursor-pointer items-center bg-white h-14 px-4 border border-black border-solid hover:bg-black hover:text-white"
        onClick={(e) => handleRequestSample(e)}
      >
        Request a Sample
      </button>

      <ModalPopup isOpen={sampleModalOpen} handleClose={setSampleModalOpen}>
        <RequestSample title={"Request Product Sample"} />
      </ModalPopup>
      <ModalPopup isOpen={emailModalOpen} handleClose={setEmailModalOpen}>
        <EmailAFriend title={"Email This Product"} />
      </ModalPopup>
    </div>
  );
}
